import classes from './NavItem.module.css';

const NavItem = (props) => {
    let navItemCalsses = [classes.NavItem];
    if(props.booking){
        navItemCalsses = [classes.NavItem, classes.Booking]
    }
    return (
        <li className={navItemCalsses.join(' ')}>
            <a href={props.link}>{props.children}</a>
        </li>
    );
}


export default NavItem;